<template>
    <div>
        <form @submit.prevent="submit">
            <div class="form-row mb-3 align-items-center">
                <div class="form-group col-lg-3">
                    <label for="city">{{ $t('omsz-form.labels.settlement') }} <span class="text-danger">*</span></label>
                    <multiselect
                        id="city"
                        v-model="city_value"
                        track-by="value"
                        label="name"
                        :placeholder="$t('omsz-form.placeholders.select')"
                        :selectLabel="$t('omsz-form.placeholders.select_enter')"
                        :selectedLabel="$t('omsz-form.placeholders.selected')"
                        :deselect-label="$t('omsz-form.placeholders.remove')"
                        :options="city"
                        :allow-empty="false"
                        :searchable="true"
                        :disabled="isDisabled"
                        :class="{'is-invalid': !isValid.cityValid}"
                        @select="selectCity">
                        <template slot="component_area" slot-scope="{ option }">{{ option.name }}</template>
                    </multiselect>
                </div>
                <div class="form-group col-lg-3">
                    <label for="type">{{ $t('omsz-form.labels.pollutant') }} <span class="text-danger">*</span></label>
                    <multiselect
                        id="type"
                        v-model="element_value"
                        track-by="value"
                        label="name"
                        :placeholder="$t('omsz-form.placeholders.select')"
                        :selectLabel="$t('omsz-form.placeholders.select_enter')"
                        :selectedLabel="$t('omsz-form.placeholders.selected')"
                        :deselect-label="$t('omsz-form.placeholders.remove')"
                        :options="element"
                        :allow-empty="false"
                        :searchable="false"
                        :disabled="isDisabled"
                        :class="{'is-invalid': !isValid.elementValid}"
                        @select="selectType">
                        <template slot="component_area" slot-scope="{ option }">{{ option.name }}</template>
                    </multiselect>
                </div>
                <div class="col-lg-3 buttons mt-2">
                    <button id="send" class="btn btn-primary" :class="{'loader': isLoading}" type="submit">
                        <span>{{ $t('omsz.buttons.start_query') }}</span>
                        <i class="icon icon-arrow-right"></i>
                    </button>
                </div>
            </div>
        </form>
        <div v-if="errorMessage">{{errorMessage}}</div>
        <div v-if="response && !errorMessage" class="vue-img-container">
            <img :src="response" alt="" class="img-fluid"/>
        </div>
    </div>
</template>
<script>
import Multiselect from "vue-multiselect"
import axios from 'axios'

export default {
    name: 'epsgram',
    components: {
        Multiselect
    },
    props: {
        cities: {
            type: Array
        },
        elements: {
            type: Array
        },
        defaultcity: {
            type: Object,
            default: ''
        },
        defaultelement: {
            type: Object,
            default: ''
        },
        defaultimageurl: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            city: '',
            city_value: '',
            element: '',
            element_value: '',
            form: {
                    city: '',
                    element: ''
                },
            isValid: {
                cityValid: true,
                elementValid: true
            },
            isLoading: false,
            isDisabled: false,
            errorMessage: '',
            response: null
        }
    },
    created() {
        this.city = this.cities;
        this.element = this.elements;
        if(this.defaultcity) {
            this.city_value = this.defaultcity
            this.form.city = this.defaultcity.value
        }
        if(this.defaultelement) {
            this.element_value = this.defaultelement
            this.form.element = this.defaultelement.value
        }

        if(this.defaultimageurl) {
            this.response = this.defaultimageurl
        }

    },
    methods: {
        selectCity(e) {
            this.isValid.cityValid = true
            this.form.city =  e.value
        },
        selectType(e) {
            this.isValid.elementValid = true
            this.form.element =  e.value
        },
        async submit(e) {
            const cityValue =  this.city_value.value
            const elementValue = this.element_value.value

            if(!cityValue) {
                this.isValid.cityValid = false
            }
            if(!elementValue) {
                this.isValid.elementValid = false
            }

            if (this.isLoading) {
                return;
            }

            this.isLoading = true;
            this.response = null;
            this.errorMessage = null;

            if(this.isValid.cityValid && this.isValid.elementValid) {


                const form = this.form

                try{
                    const data = await axios.post("/api/modelling/epsgram", form, {
                        headers: { 'Accept-Language': window.Met.locale }
                    })

                    this.response = data.data.imageUrl
                }
                catch (error) {
                    this.errorMessage = this.$t('omsz-form.errors.not_response')
                }
                finally {
                    this.isLoading = false
                }
            }
        }
    }
}
</script>
